import { useApolloClient } from '@apollo/client'
import { AugmentedCache } from './cache'

export const useShortIdsMapper = () => {
  const client = useApolloClient()
  return (client.cache as AugmentedCache).shortIdsMapper
}
